export function trimmingFields<T>(obj: T) {
  return Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      // @ts-ignore
      [key]: typeof obj[key] === 'string' ? obj[key]?.trim() : obj[key]
    }),
    {}
  );
}
